export enum UserStatus {
  New = 'NEW',
  Active = 'ACTIVE',
}
